import { getStorageOwner } from "./privacy/ownerStorage";
import { supabase } from "./supabase";
export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    message: string,
  ) {
    super(message);
  }
}
export async function apiRequest<T>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const expected = getStorageOwner();
  const { data } = supabase
    ? await supabase.auth.getSession()
    : { data: { session: null } };
  const current = getStorageOwner();
  if (
    path !== "/account/bootstrap" &&
    (current.userId !== expected.userId ||
      current.tenantId !== expected.tenantId ||
      (data.session && data.session.user.id !== expected.userId))
  ) {
    throw new ApiError(
      409,
      "session_changed",
      "Account changed. Retry from the current session.",
    );
  }
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 15000);
  try {
    const response = await fetch(`/api${path}`, {
      ...init,
      headers: {
        "Content-Type": "application/json",
        ...(data.session
          ? { Authorization: `Bearer ${data.session.access_token}` }
          : {}),
        ...init.headers,
      },
      signal: init.signal ?? controller.signal,
      cache: "no-store",
    });
    const body: unknown = await response.json().catch(() => null);
    if (!response.ok) {
      const error =
        body && typeof body === "object"
          ? (body as Record<string, unknown>)
          : {};
      throw new ApiError(
        response.status,
        typeof error.code === "string" ? error.code : "request_failed",
        typeof error.message === "string"
          ? error.message
          : "Service unavailable. Your local work is unchanged.",
      );
    }
    return body as T;
  } finally {
    clearTimeout(timer);
  }
}
